import React from 'react';
import Col from 'react-bootstrap/Col';
import ReviewQuoteIcon from '../../svgs/reviewquote.svg';
import { TrustedHtmlString } from '../../models/globals';

interface ReviewItemProps {
    quote: TrustedHtmlString;
    className?: string;
}

const ReviewItem: React.FC<ReviewItemProps> = ({ quote, className = '' }) => {
    if (!quote.length) return null;

    return (
        <Col>
            <div className={`e2g-reviews_icon ${className}`.trim()}>
                <ReviewQuoteIcon className="text-white" />
            </div>
            <p className="font-italic mx-5 px-5" dangerouslySetInnerHTML={{ __html: quote }} />
        </Col>
    );
};

export { ReviewItem, ReviewItemProps };
